import * as React from "react";

// Create a React component to wrap the custom element
const Cc8Header = () => {
  return React.createElement("cc8-header");
};

export default Cc8Header;
